import axios from 'axios';
import { API } from './catalog';

export const adminApi = axios.create({ baseURL: API, withCredentials: true });
let csrf = '';
export const setAdminCsrf = (value) => { csrf = value || ''; };
let refreshPromise = null;
adminApi.interceptors.request.use(config => {
  if (csrf && ['post', 'patch', 'delete', 'put'].includes(config.method)) config.headers['X-CSRF-Token'] = csrf;
  return config;
});
adminApi.interceptors.response.use(response => response, async error => {
  const config = error.config;
  if (error.response?.status === 401 && config && !config._retried && !config.url.includes('/auth/login') && !config.url.includes('/auth/refresh')) {
    config._retried = true;
    if (!refreshPromise) refreshPromise = axios.post(`${API}/admin/auth/refresh`, {}, { withCredentials: true })
      .then(r => { setAdminCsrf(r.data.csrfToken); return r.data; }).finally(() => { refreshPromise = null; });
    try { await refreshPromise; return adminApi(config); } catch { setAdminCsrf(''); }
  }
  return Promise.reject(error);
});
export const apiError = error => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return 'Provjerite unesene podatke.';
  return 'Zahtjev trenutno nije moguće dovršiti.';
};
export const emailStates = {
  not_queued: 'Čeka uplatu', queued: 'Čeka slanje', sending: 'Slanje u tijeku', retry: 'Ponovni pokušaj',
  smtp_accepted: 'Predano mail poslužitelju', failed: 'Slanje nije uspjelo', delivery_unknown: 'Dostava zahtijeva provjeru'
};